import api from './api.service';

export interface Host {
  id: string;
  tenant_id: string;
  hostname: string;
  ip_address: string;
  os?: string;
  os_version?: string;
  status: 'online' | 'offline' | 'degraded';
  metadata?: {
    cpu_usage?: number;
    memory_usage?: number;
    disk_usage?: number;
    network_in?: number;
    network_out?: number;
    uptime?: string;
    [key: string]: any;
  };
  last_seen_at?: string;
  created_at: string;
  updated_at: string;
}

export const hostApi = {
  getHosts: async (limit: number = 50, offset: number = 0): Promise<{ success: boolean; data: Host[]; meta: { total: number; limit: number; offset: number } }> => {
    const response = await api.get<{ success: boolean; data: Host[]; meta: { total: number; limit: number; offset: number } }>(
      `/v1/infrastructure/hosts?limit=${limit}&offset=${offset}`
    );
    return response;
  },

  getHost: async (id: string): Promise<Host> => {
    const response = await api.get<{ success: boolean; data: Host }>(`/v1/infrastructure/hosts/${id}`);
    return response.data;
  },

  createHost: async (data: Partial<Host>): Promise<Host> => {
    const response = await api.post<{ success: boolean; data: Host }>('/v1/infrastructure/hosts', data);
    return response.data;
  },

  updateHost: async (id: string, data: Partial<Host>): Promise<Host> => {
    const response = await api.put<{ success: boolean; data: Host }>(`/v1/infrastructure/hosts/${id}`, data);
    return response.data;
  },

  deleteHost: async (id: string): Promise<void> => {
    await api.delete(`/v1/infrastructure/hosts/${id}`);
  },
};
